import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Tabs } from 'ionic-angular';

import { ConsumerBusinessOfferListPage } from '../consumer-business-offer-list/consumer-business-offer-list';
import { ConsumerBusinessPunchCardListPage } from '../consumer-business-punch-card-list/consumer-business-punch-card-list';
import { ConsumerBusinessTimelinePage } from '../consumer-business-timeline/consumer-business-timeline';

import { DefaultLoadingPage } from '../default-loading/default-loading';

import { ConsumerBusinessMainHandlerProvider } from '../../providers/consumer-business-main-handler';

@Component({
  selector: 'page-consumer-business-main',
  templateUrl: 'consumer-business-main.html',
})
export class ConsumerBusinessMainPage {
  @ViewChild('myTabs') tabRef: Tabs;
  business: any;
  activeTab: number;

	offers: any = DefaultLoadingPage;
	rewards: any = DefaultLoadingPage;
	messages: any = DefaultLoadingPage;

  constructor(
    public consumerBusinessMainHandlerProvider: ConsumerBusinessMainHandlerProvider, 
    public navCtrl: NavController, 
    public navParams: NavParams) {

    this.offers = DefaultLoadingPage;
    this.rewards = DefaultLoadingPage;
    this.messages = DefaultLoadingPage;

    consumerBusinessMainHandlerProvider.business = navParams.get('business');
    this.activeTab = navParams.get('activeTab');
  }

  ionViewWillEnter() {
    this.offers = ConsumerBusinessOfferListPage;
    this.rewards = ConsumerBusinessPunchCardListPage;
    this.messages = ConsumerBusinessTimelinePage;
  }

  ionViewDidEnter() {
    this.tabRef.select(this.activeTab);
    
    console.log('ionViewDidEnter ConsumerBusinessMainPage');
  }

  ionViewWillLeave() {
    console.log('ionViewDidLeave ConsumerBusinessMainPage');
  }  

  ionViewDidLeave() {
    console.log('ionViewDidLeave ConsumerBusinessMainPage');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ConsumerBusinessMainPage');
  }
}


// WEBPACK FOOTER //
// ./src/pages/consumer-business-main/consumer-business-main.ts